/**
 * CreateGeneralEventButton Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { Schema } from 'services/schemas/types';
import { selectEnabledChecklistSchemas, selectEnabledGeneralSchemas } from '../../../../services/schemas/selectors';

// Utils
// @ts-ignore
import orderBy from '../../../../utils/custom-orderBy';
import { SCHEMA_CATEGORY_CHECKLIST } from '../../../../services/schemas/constants';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectData = createDeepEqualSelector(
    selectEnabledGeneralSchemas,
    schemasState => schemasState
);

const selectFormattedData = createDeepEqualSelector(
    selectEnabledChecklistSchemas,
    selectEnabledGeneralSchemas,
    (checklistSchemas, generalSchemas) => {
        if (checklistSchemas.length) {
            generalSchemas.push({
                id: SCHEMA_CATEGORY_CHECKLIST,
                name: 'Checklist',
                category: SCHEMA_CATEGORY_CHECKLIST
            } as any)
        }

        return generalSchemas;
    });

const selectOrderedData = createDeepEqualSelector(
    selectFormattedData,
    filteredDataState => orderBy(filteredDataState, 'name')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    (orderedDataState: Schema[]) =>
        orderedDataState &&
        orderedDataState.map(({ id, name }) => ({
            key: id,
            text: name,
            value: id
        }))
);

const makeSelectOptions = (): typeof selectOptions => selectOptions;


export { selectData, selectFormattedData as selectFilteredData, selectOrderedData, makeSelectOptions };
